import { create } from 'zustand';

type SessionStore = {
  sessionId: string | null;
  videoId: string | null;
  remainingSeconds: number;
  sessionStart: number | null;
  setSession: (sessionId: string, videoId: string, remainingSeconds: number) => void;
  updateRemaining: (seconds: number) => void;
  clearSession: () => void;
};

export const useSessionStore = create<SessionStore>((set) => ({
  sessionId: null,
  videoId: null,
  remainingSeconds: 0,
  sessionStart: null,

  setSession: (sessionId, videoId, remainingSeconds) =>
    set({ sessionId, videoId, remainingSeconds, sessionStart: Date.now() }),

  updateRemaining: (seconds) => set({ remainingSeconds: seconds }),

  clearSession: () =>
    set({ sessionId: null, videoId: null, remainingSeconds: 0, sessionStart: null }),
}));
